import { useEffect } from 'react'
import { clearFormBehaviorState } from '@app-store'
import { useAppDispatch } from '../utils/agent.store'
import { useFormBehaviorEngine } from './useFormBehaviorEngine'
import { FormBehaviorRunnerProps } from '../types/formBehavior.types'

export const FormBehaviorRunner = ({
  layoutUid,
  rules,
  setValue,
  getValues,
  reset,
  formInstanceId,
  formUniqueId,
  entityName,
  children,
}: FormBehaviorRunnerProps) => {
  const dispatch = useAppDispatch()

  useFormBehaviorEngine(
    layoutUid,
    rules,
    setValue,
    getValues,
    reset,
    dispatch,
    formInstanceId,
    formUniqueId,
    entityName
  )

  useEffect(() => {
    return () => {
      dispatch(clearFormBehaviorState(layoutUid))
    }
  }, [dispatch, layoutUid])

  return <>{children}</>
}
